import { render, staticRenderFns } from "./platformAuthorization.vue?vue&type=template&id=349d1124"
import script from "./platformAuthorization.vue?vue&type=script&lang=js"
export * from "./platformAuthorization.vue?vue&type=script&lang=js"
import style0 from "./platformAuthorization.vue?vue&type=style&index=0&id=349d1124&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports